
export default [
{
  "id": 1,
  "name": "学科試験",
  "no": 1,
  "grade": 2,
  "time": 120
},
{
  "id": 2,
  "name": "資産設計提案業務",
  "no": 2,
  "grade": 2,
  "time": 90
},
{
  "id": 3,
  "name": "個人資産相談業務",
  "no": 3,
  "grade": 2,
  "time": 90
},
{
  "id": 4,
  "name": "生保顧客資産相談業務",
  "no": 4,
  "grade": 2,
  "time": 90
},
{
  "id": 5,
  "name": "学科試験",
  "no": 3,
  "grade": 2,
  "time": 120
},
{
  "id": 6,
  "name": "資産設計提案業務",
  "no": 3,
  "grade": 2,
  "time": 90
},
{
  "id": 7,
  "name": "個人資産相談業務",
  "no": 3,
  "grade": 2,
  "time": 90
},
{
  "id": 8,
  "name": "生保顧客資産相談業務",
  "no": 3,
  "grade": 2,
  "time": 90
},

{
  "id": 9,
  "name": "第１回目 予想模試  学科試験",
  "no": 3,
  "grade": 2,
  "time": 120
},
{
  "id": 10,
  "name": "第１回目 予想模試  資産設計提案業務",
  "no": 3,
  "grade": 2,
  "time": 90
},
{
  "id": 11,
  "name": "第１回目 予想模試  個人資産相談業務",
  "no": 3,
  "grade": 2,
  "time": 90
},
{
  "id": 12,
  "name": "第１回目 予想模試  生保顧客資産相談業務",
  "no": 3,
  "grade": 2,
  "time": 90
},

{
  "id": 13,
  "name": "第２回目 予想模試  学科試験",
  "no": 3,
  "grade": 2,
  "time": 120
},
{
  "id": 14,
  "name": "第２回目 予想模試  資産設計提案業務",
  "no": 3,
  "grade": 2,
  "time": 90
},
{
  "id": 15,
  "name": "第２回目 予想模試  個人資産相談業務",
  "no": 3,
  "grade": 2,
  "time": 90
},
{
  "id": 16,
  "name": "第２回目 予想模試  生保顧客資産相談業務",
  "no": 3,
  "grade": 2,
  "time": 90
},

{
  "id": 17,
  "name": "第３回目 予想模試  学科試験",
  "no": 3,
  "grade": 2,
  "time": 120
},
{
  "id": 18,
  "name": "第３回目 予想模試  資産設計提案業務",
  "no": 3,
  "grade": 2,
  "time": 90
},
{
  "id": 19,
  "name": "第３回目 予想模試  個人資産相談業務",
  "no": 3,
  "grade": 2,
  "time": 90
},
{
  "id": 20,
  "name": "第３回目 予想模試  生保顧客資産相談業務",
  "no": 3,
  "grade": 2,
  "time": 90
},
]